import React, { useEffect, useState } from 'react';
const headlines = ['Wie arbeiten wir als Führungsteam gut zusammen?', 'Was braucht ein Team für einen guten Start?', 'Wie lassen sich Konflikte und Blockaden lösen?'];
export const TeamentwicklungPage: React.FC = () => {
  const [currentHeadline, setCurrentHeadline] = useState(0);
  const [fadeState, setFadeState] = useState<'visible' | 'fading'>('visible');
  useEffect(() => {
    const interval = setInterval(() => {
      setFadeState('fading');
      setTimeout(() => {
        setCurrentHeadline(prev => (prev + 1) % headlines.length);
        setFadeState('visible');
      }, 500);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  return <>
      <section className="w-full bg-white py-16 px-6 md:px-12 lg:px-20" data-id="element-774">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-775">
          <div data-id="element-776">
            <h1 className="text-3xl md:text-4xl text-orange-500 font-light mb-6 transition-opacity duration-500" style={{
            opacity: fadeState === 'visible' ? 1 : 0,
            minHeight: '120px'
          }} data-id="element-777">
              {headlines[currentHeadline]}
            </h1>
          </div>
          <div className="flex justify-center" data-id="element-778">
            <img src="https://cdn.magicpatterns.com/uploads/cRsLQo3uL6AXRZcvRJQ9Bk/Eva-Schifferer-Change_Beratung-Teamentwicklung.png" alt="Teamentwicklung" className="max-h-80 object-contain" data-id="element-779" />
          </div>
        </div>
      </section>

      <section className="w-full text-white py-16 px-6 md:px-12 lg:px-20" style={{
      backgroundColor: '#545454'
    }} data-id="element-780">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-781">
          <div data-id="element-782">
            <p className="mb-6 text-base leading-relaxed" data-id="element-783">
              Spitzenleistung ist möglich! Anlässe für Teamentwicklung sind
              vielfältig: für Teams in Veränderungsprozessen, neu
              zusammengestellte Teams, Executive Teams oder erfahrene Teams in
              Konfliktsituationen.
            </p>
            <p className="mb-6 text-base leading-relaxed" data-id="element-784">
              Unterschiedliche Formate wie Workshops, Coaching Sessions und
              Teambuilding unterstützen darin, sich gemeinsam erfolgreich auf
              Ergebnisse zu fokussieren – so dass das Ganze mehr ist als die
              Summe der Teile.
            </p>
          </div>
          <div data-id="element-785">
            <p className="mb-6 text-base leading-relaxed" data-id="element-786">
              Neben einer Klärung von Zielen, Rollen, Prozessen und
              Stakeholdermanagement stehen auch „vermeintlich softe" Themen wie
              die Spielregeln der Zusammenarbeit, die Klärung von Konflikten und
              die Beziehungsgestaltung unter den Teammitgliedern im Fokus.
            </p>
            <p className="mb-6 text-base leading-relaxed" data-id="element-787">
              Als Team Coach unterstütze ich Ihre Teams mit Klarheit,
              Inspiration, Wertschätzung und Prozesssicherheit – gerade auch in
              schwierigen Phasen der Veränderung oder bei festgefahrenen
              Konflikten.
            </p>
            <p className="mb-6 text-base leading-relaxed" data-id="element-788">
              Lassen Sie uns darüber sprechen und nehmen Sie Kontakt auf!
            </p>
            <a href="/kontakt" className="inline-block bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 transition-colors" data-id="element-789">
              Lassen Sie uns sprechen
            </a>
          </div>
        </div>
      </section>
    </>;
};